module.exports = __webpack_public_path__ + "static/img/70.dedc9d4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/70 184/70.gif
// module id = i4w6
// module chunks = 7